import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

export const fileDropzoneVariants = cva(
  cn(
    'flex flex-col items-center justify-center',
    'rounded-lg border-2 border-dashed border-border',
    'px-6 py-12 text-center',
    'transition-colors duration-200 ease-out',
    focusRing
  ),
  {
    variants: {
      variant: {
        default: 'bg-surface',
        subtle: 'bg-surface-accent',
      },
      isDragActive: {
        true: 'border-border-focus',
        false: '',
      },
      isDisabled: {
        true: 'cursor-not-allowed opacity-50',
        false: 'cursor-pointer',
      },
    },
    compoundVariants: [
      {
        variant: 'default',
        isDragActive: true,
        className: 'bg-surface-accent',
      },
      {
        variant: 'subtle',
        isDragActive: true,
        className: 'bg-surface-accent-hover',
      },
      {
        variant: 'default',
        isDragActive: false,
        isDisabled: false,
        className: 'hover:border-border-strong-hover hover:bg-surface-hover',
      },
      {
        variant: 'subtle',
        isDragActive: false,
        isDisabled: false,
        className: 'hover:border-border-strong-hover hover:bg-surface-accent-hover',
      },
    ],
    defaultVariants: {
      variant: 'default',
      isDragActive: false,
      isDisabled: false,
    },
  }
);
